import NotesActions from '../actions/NotesCRUDActions';
import { setUnBusy, setBusy } from './common/commonReducers';
import { handleActions } from 'redux-actions';

type ActionType = {
  type: string;
};

const initialState = {
  busy: false,
};

const mappedReducers = {
  [NotesActions.busyAction]: setBusy,
  [NotesActions.unbusyAction]: setUnBusy,
};

const notes = handleActions(mappedReducers, initialState);

export default notes;
